import { Star, Speedometer, ShieldCheckmark } from '@raresail/react-ionicons';

/** Route to the one-time-code page, preserving the current query string. */
export function goToCodeSignIn(router, account) {
  const url = new URL(window.location.href);
  url.pathname = '/auth/sign-in/code';
  url.searchParams.set('account', account);
  router.push(url.toString());
}

// Translations address <Trans> children by position — keep these at the
// same child index as the <a> tags they replaced.
export function TermsLink({ className = 'underline text-base-content', children }) {
  return (
    <a
      href="https://www.beautifi.com/terms-of-service/"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

export function PrivacyLink({ className = 'underline text-base-content', children }) {
  return (
    <a
      href="https://www.beautifi.com/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

export function signInFeatureItems(t) {
  return [
    {
      icon: Star,
      title: t('login.new.features.instant.title', 'Get Qualified Instantly'),
      description: t(
        'login.new.features.instant.description',
        'Apply in under 2 minutes and get approved for up to $50,000.'
      )
    },
    {
      icon: Speedometer,
      title: t(
        'login.new.features.credit.title',
        'No Impact on Your Credit Score'
      ),
      description: t(
        'login.new.features.credit.description',
        "Checking your eligibility won't affect your credit, get peace of mind before you commit."
      )
    },
    {
      icon: ShieldCheckmark,
      title: t('login.new.features.flexible.title', 'Apply Now, Decide Later'),
      description: t(
        'login.new.features.flexible.description',
        'View your monthly payment offers today with the flexibility to finalize your details later.'
      )
    }
  ];
}
